"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_2 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const setTime_1 = require("../../../utils/setTime");
const zustandStore_1 = require("../../../zustandStore");
const Alert = (0, react_1.forwardRef)(function Alert(props, ref) {
    return (0, jsx_runtime_1.jsx)(material_1.Alert, { elevation: 6, ref: ref, variant: "outlined", ...props });
});
const defaultAlert = { type: '', message: '', onClose: lodash_1.default.noop, timeout: 0 };
const defaultMessages = {
    success: 'Success',
    warning: 'Warning',
    error: 'Error',
    info: 'Info',
};
const NotificationComponent = () => {
    const alerts = (0, zustandStore_1.useZustand)(state => state.notification?.alerts);
    const [alert, setAlert] = (0, react_1.useState)(defaultAlert);
    const [open, setOpen] = (0, react_1.useState)(false);
    const location = (0, react_router_1.useLocation)();
    (0, react_1.useEffect)(() => {
        if (alerts.length === 0) {
            return;
        }
        const latestAlert = alerts.at(-1) || defaultAlert;
        setAlert({
            ...latestAlert,
            onClose: latestAlert.onClose || lodash_1.default.noop,
            timeout: latestAlert.timeout || (0, setTime_1.setTime)(3, 'seconds'),
        });
        setOpen(true);
        return () => {
            setAlert(defaultAlert);
            setOpen(false);
        };
    }, [alerts]);
    (0, react_1.useEffect)(() => {
        // we want to close the notification when the location changes
        setAlert(defaultAlert);
        setOpen(false);
    }, [location]);
    const handleClose = (_event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        if (typeof alert.onClose === 'function') {
            alert.onClose();
        }
        setAlert(defaultAlert);
        setOpen(false);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Snackbar, { "data-testid": "notification", open: open, autoHideDuration: window['IS_PLAYWRIGHT_RUNNING'] ? (0, setTime_1.setTime)(10, 'seconds') : alert.timeout || (0, setTime_1.setTime)(3, 'seconds'), onClose: handleClose, anchorOrigin: { vertical: 'top', horizontal: 'right' }, children: (0, jsx_runtime_1.jsx)(Alert, { severity: alert.type, "ts-variant": "notification", children: alert.message != null && (typeof alert.message === 'string' || react_2.default.isValidElement(alert.message))
                ? alert.message
                : defaultMessages[alert.type] || '' }) }));
};
exports.default = NotificationComponent;
